/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CampaignIcon = ({ width = 24, height = 24, hidden = false, title = 'Campaign' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <circle cx="18" cy="18" r="4.3" />
    <path
      d="M6.227 20.311H2A16.172 16.172 0 0 0 15.688 34v-4.227a12.007 12.007 0 0 1-9.461-9.462ZM29.773 20.311a12.007 12.007 0 0 1-9.461 9.462V34A16.172 16.172 0 0 0 34 20.311ZM15.688 6.228V2A16.171 16.171 0 0 0 2 15.688h4.228a12 12 0 0 1 9.46-9.46ZM29.772 15.688H34A16.171 16.171 0 0 0 20.312 2v4.228a12 12 0 0 1 9.46 9.46Z"
    />
  </svg>`;
};
